export const DELETE_ACCOUNT_API_ERRORS = {
  SubscriptionExists: 'EB000U0203', // 'Unable to remove the account. Subscription exists in the account.'
  DeviceWithActiveShares: 'EB000U0408', // 'Cannot remove the device with active shares.'
  Forbidden: 'EB000U0001', // Forbidden
  Default: 'DEFAULT'
};
